import { useEffect, useState } from "react";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { fetchFaqs } from "../redux/faqSlice";
import { getFaqBanners } from "../services/faqService";

export default function useFaqData() {
    const dispatch = useDispatch();
    const { faqs, loading, error } = useSelector(
        (state) => state.faq,
        shallowEqual
    );

    const [banner, setBanner] = useState(null);

    useEffect(() => {
        let isMounted = true;
        document.title = "Obsession - FAQ";

        if (!faqs?.length) {
            dispatch(fetchFaqs());
        }

        getFaqBanners()
            .then((res) => {
                if (isMounted && res.data?.success) {
                    setBanner(res.data.data);
                }
            })
            .catch(() => console.warn("FAQ banner failed"));

        return () => {
            isMounted = false;
        };
    }, [dispatch, faqs?.length]);

    return { faqs, banner, loading, error };
}
